(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Omnify-Hero-Banner"] && !Shopify.designMode) return;
  try {
    
/* Geen JS vereist — laat leeg voor performance */

  } catch(e) { console.error(e); }
})();
})();
